import { Agent } from "Models/agent";
import { createAgentValidationSchema } from "./agentSchema";
import { createContactValidationSchema } from "./contactSchema";
import { createLocationValidationSchema } from "./locationSchema";
import * as yup from "yup";
import { UseState } from "Types";

export const handleAgentValidation = (params: { translate: any, agent: Agent, setErrors: UseState<yup.ValidationError[]>, skipContactsNestedValidations?: boolean, skipLocationsNestedValidations?: boolean }) => {
  const { translate, agent, setErrors, skipContactsNestedValidations, skipLocationsNestedValidations } = params
  try {
    const agentSchema = createAgentValidationSchema({ translate });
    const contactSchema = createContactValidationSchema({ translate });
    const locationSchema = createLocationValidationSchema({ translate });

    // Validação do agente principal
    agentSchema.validateSync(
      {
        entity: agent?.entity,
        website: agent?.website,
        registrationNumber: agent?.registrationNumber,
        agentId: agent?.code,
        established: agent?.established,
        status: agent?.status,
        mobile: agent?.phone,
        consultant: agent?.consultantId,
        timezone: agent?.timezoneId,
      },
      { abortEarly: false }
    );

    const validationErrors: yup.ValidationError[] = [];

    // Validação de contacts
    if (!agent?.contacts || agent.contacts.length === 0) {
      validationErrors.push(
        new yup.ValidationError(
          translate("youMustHaveAtLeastOneContact"),
          agent?.contacts,
          "contacts"
        )
      );
    } else {
      // Verificar se há pelo menos um contact primário
      const hasPrimaryContact = agent.contacts.some(contact => contact.isPrimary);
      if (!hasPrimaryContact) {
        validationErrors.push(
          new yup.ValidationError(
            translate("youMustHaveAtLeastOnePrimaryContact"),
            agent?.contacts,
            "contacts.primary"
          )
        );
      }

      if (!skipContactsNestedValidations) {
        agent.contacts.forEach((contact, index) => {
          try {
            contactSchema.validateSync({
              firstName: contact.firstName,
              lastName: contact.lastName,
              email: contact.email,
              contactType: contact.contactType,
            }, { abortEarly: false });
          } catch (error) {
            if (error instanceof yup.ValidationError) {
              error.inner.forEach(innerError => {
                validationErrors.push(
                  new yup.ValidationError(
                    innerError.message,
                    innerError.value,
                    `contacts[${index}].${innerError.path}`
                  )
                );
              });
            }
          }
        });
      }
    }

    if (!agent?.locations || agent.locations.length === 0) {
      validationErrors.push(
        new yup.ValidationError(
          translate("youMustHaveAtLeastOneLocation"),
          agent?.locations,
          "locations"
        )
      );
    } else if (!skipLocationsNestedValidations) {
      agent.locations.forEach((location, index) => {
        try {
          locationSchema.validateSync({
            locationName: location.name,
            contactPerson: location.contact?.firstName,
            status: location.status,
            address: location.longAddress,
          }, { abortEarly: false });
        } catch (error) {
          if (error instanceof yup.ValidationError) {
            error.inner.forEach(innerError => {
              validationErrors.push(
                new yup.ValidationError(
                  innerError.message,
                  innerError.value,
                  `locations[${index}].${innerError.path}`
                )
              );
            });
          }
        }
      });
    }

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return false;
    }

    setErrors([]);
    return true;

  } catch (error) {
    if (error instanceof yup.ValidationError) {
      setErrors(error?.inner);
      return false;
    }
    return false;
  }
};